import {charcoal} from '../../sass/v2/_exports.sass';

export const ShareIcon = ({color = charcoal, className = '', ratio = 1}) => {
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6667 21.3333H17.3333V9.33333H21.3333L16 2.66666L10.6667 9.33333H14.6667V21.3333Z"
        fill={color}
      />
      <path
        d="M6.66667 29.3333H25.3333C26.804 29.3333 28 28.1373 28 26.6667V14.6667C28 13.196 26.804 12 25.3333 12H20V14.6667H25.3333V26.6667H6.66667V14.6667H12V12H6.66667C5.196 12 4 13.196 4 14.6667V26.6667C4 28.1373 5.196 29.3333 6.66667 29.3333Z"
        fill={color}
      />
    </svg>
  );
};
